import {
	Button,
	ButtonProps,
	ChildrenProps,
	Column,
	Conditional,
	Else,
	If,
	makeClassName,
	Row,
} from "@hex-insights/core";
import { Icon } from "../Icon";
import { useWizardNavigation, WizardNavigationRoute, WizardNavigationRouter } from "./context";
import styles from "./styles.module.css";

export { useWizardNavigation } from "./context";

export type WizardNavigationProps = Partial<ChildrenProps>;

export function WizardNavigation({ children }: WizardNavigationProps) {
	return (
		<Column justify="spaced-start" verticalSpacing="1.5rem" className={styles["navigation"]}>
			{children}
		</Column>
	);
}

export type WizardNavigationButtonProps<T extends number> = {
	page: T;
} & Pick<ButtonProps, "className" | "style" | "children">;

WizardNavigation.Button = function <T extends number>({
	page,
	className,
	style,
	children,
}: WizardNavigationButtonProps<T>) {
	const { page: currentPage, setPage } = useWizardNavigation<T>();

	let status = "future";
	if (page === currentPage) {
		status = "current";
	} else if (page < currentPage) {
		status = "past";
	}

	return (
		<Button
			onClick={() => setPage(page)}
			className={makeClassName(styles["navigation-button"], styles[`navigation-button--${status}`], className)}
			style={style}
		>
			<Row justify="spaced-start" align="center">
				<div className={styles["navigation-button__icon"]}>
					<span className={styles["navigation-button__icon__content"]}>
						<Conditional>
							<If condition={page >= currentPage}>{page + 1}</If>
							<Else>
								<Icon.Check size={16} className="block" />
							</Else>
						</Conditional>
					</span>
				</div>
				{children}
			</Row>
		</Button>
	);
};

WizardNavigation.Router = WizardNavigationRouter;
WizardNavigation.Route = WizardNavigationRoute;
